<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>Inventory</CCardHeader>
      <CCardBody>
        <!-- <div style="width:100%;float:left;text-align:center;">
          Incoming inventory is currently not available. We're currently re-working this process.
        </div> -->
        <div style="width:100%;float:left;text-align:center;margin-bottom:10px;" v-if="customer">
          <v-select v-if="styleOptions" placeholder="Select Type..." label="style_name" @input="getInventory()" :options="filterOptions" v-model="filter" style="width:250px;margin-left:auto;margin-right:auto;"></v-select>
        </div>
        <div style="width:100%;float:left;text-align:center;" v-if="filter == 'Blank Inventory'">
          <v-select v-if="styleOptions" placeholder="Select Style..." label="style_name" @input="getInventory()" :options="styleOptions" v-model="style" style="width:250px;margin-left:auto;margin-right:auto;"></v-select>
        </div>
        <div style="width:100%;float:left;" v-if="style && style.dropping_style">
          <label style="color:orange;font-size: .8em;">Attention: We will be dropping this style in 2026. If you have any questions, please contact your CSR.</label>
        </div>
        <div style="width:100%;float:left;" v-if="items && !loading">
          <CButton
            color="primary"
            class="mb-2 float-right"
            :href="csvCode" 
            :download="configureName()"
            target="_blank"
            size="sm"
          >
            Download current Table
          </CButton>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
            sorter
            pagination
            :itemsPerPage="20"
          >
            <template #incoming_1="{item}">
              <td>
                <label style="width:100%;float:left;text-align:center;padding:0px;margin:0;">{{item.incoming_units_1}}</label>
                <label style="color: #a1a1a1;width:100%;float:left;text-align:center;padding:0px;margin:0;">{{configureDate(item.incoming_date_1)}}</label>
              </td>
            </template>
            <template #incoming_2="{item}">
              <td>
                <label style="width:100%;float:left;text-align:center;padding:0px;margin:0;">{{item.incoming_units_2}}</label>
                <label style="color: #a1a1a1;width:100%;float:left;text-align:center;padding:0px;margin:0;">{{configureDate(item.incoming_date_2)}}</label>
              </td>
            </template>
            <template #quantity_on_order="{item}">
              <td>
                {{ item.quantity_on_order ? item.quantity_on_order : '0' }}
              </td>
            </template>
            <template #total_available="{item}">
              <td>
                <!-- <div style="width:100%;float:left;" v-if="item.planninggroup == 'A' || item.planninggroup == 'B'">
                  {{ item.total_on_hand ? item.total_on_hand : '0' }}
                </div> -->
                <div style="width:100%;float:left;">
                  {{ item.total_available ? item.total_available : '0' }}
                </div>
              </td>
            </template>
            <template #quantity_in_transit="{item}">
              <td>
                {{ item.quantity_in_transit ? item.quantity_in_transit : '0' }}
              </td>
            </template>
            <template #incoming_3="{item}">
              <td>
                <label style="width:100%;float:left;text-align:center;padding:0px;margin:0;">{{item.incoming_units_3}}</label>
                <label style="color: #a1a1a1;width:100%;float:left;text-align:center;padding:0px;margin:0;">{{configureDate(item.incoming_date_3)}}</label>
              </td>
            </template>
            <template #incoming_4="{item}">
              <td>
                <label style="width:100%;float:left;text-align:center;padding:0px;margin:0;">{{item.incoming_units_4}}</label>
                <label style="color: #a1a1a1;width:100%;float:left;text-align:center;padding:0px;margin:0;">{{configureDate(item.incoming_date_4)}}</label>
              </td>
            </template>

          </CDataTable>
        </div>
        <small-loader v-else-if="loading"></small-loader>
      </CCardBody>
    </CCard>

    <CModal
      :show="showIncomingModal"
      @close="showIncomingModal = false"
      size="xl"
    >
      <template #header>
        <div class="modal-header w-100 d-flex justify-content-between align-items-center">
          <h5 class="modal-title mb-0">Incoming Inventory</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            @click="showIncomingModal = false"
          >X</button>
        </div>
      </template>

      <CModalBody>
        <div style="width:100%;float:left;" v-if="incomingData">
          <div v-if="loadingIncoming">
            <small-loader />
          </div>
          <div v-else>
            <CCol sm="12" style="padding:15px;border-radius:5px;">
              <table class="table" style="font-size: .9em;">
                <thead>
                  <tr>
                    <th style="text-align:center;">Style</th>
                    <th style="text-align:center;">Quantity</th>
                    <th style="text-align:center;">Expected Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in incomingData" :key="index">
                    <td style="text-align:center;">{{ item.item_name }}</td>
                    <td style="text-align:center;">{{ item.total_ordered_qty }}</td>
                    <td style="text-align:center;">{{ formatFullDate(item.expected_receipt) }}</td>
                  </tr>
                </tbody>
              </table>
            </CCol>
          </div>
        </div>
      </CModalBody>

      <template #footer>
        <div style="width:100%;float:left;"></div>
      </template>
    </CModal>

    
  </div>
</template>
<script>
var methods = {}

methods.configureDate = function (date) {
  var r = ''
  if (date) {
    r = moment(date).format('MM/DD')
  }
  return r
}

methods.configureName = function () {
  var name = ''
  if (this.style) {
    name = this.style.style_name + '_' + moment().format('YYYY-MM-DD') + '.csv'
  }
  return name
}

methods.getInventory = function () {
  this.loading = true
  if ((this.filter == 'Blank Inventory' && this.style) || this.filter == 'FG Customer Inventory') {
    const postData = {
      style: this.style,
      filter: this.filter,
      customer: this.customer
    }
    console.log(postData)
    axios.post(this.$apiAdress + '/api/styles/getInventory?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log('Inventory RESPONSE------>', response.data.items)
      // this.items = response.data.items
      this.items = response.data.items.filter(item => item.total_available > 0)
      this.loading = false
    })
  } else {
    this.loading = false
  }
}

methods.getInventoryDetails = function (value) {  
  this.loadingIncoming = true;
    this.showIncomingModal = true;
    this.incomingData = [];

    axios.post(this.$apiAdress + '/api/styles/getIncomingInventory?token=' + localStorage.getItem('api_token'), {
      style: this.style,
      sizes: [value]  // or adapt depending on your API input
    })
    .then(response => {
      this.incomingData = response.data.items;
    })
    .catch(error => {
      console.error('Error fetching incoming inventory:', error);
    })
    .finally(() => {
      this.loadingIncoming = false;
    });
}

methods.formatFullDate = function (date) {
  if (!date) return '';
  return moment(date).format('MM-YYYY');
}

methods.getStyles = function () {
  axios.get(this.$apiAdress + '/api/styles?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    this.styleOptions = response.data
  })
}

export default {
  // ===Component name
  name: "IncomingInventory",
  // ===Props passed to component
  props: ['customer'],
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        items: null,
        // fields: ['color_name', 'color_code', 'size_name', 'available_quantity', 'on_order'],
        fields: ['style', 'color', 'size', 'total_available'],
        // fields: ['style', 'color', 'size', 'quantity_on_order', 'total_on_hand', 'quantity_in_transit'],
        style: '',
        styleOptions: null,
        loading: false,
        filter: 'Blank Inventory',
        filterOptions: ['Blank Inventory', 'FG Customer Inventory']
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getStyles()
  },
  // ===Computed properties for the component
  computed: {
    csvContent () {
      if (this.items) {
        var content = this.items
        var headers = []
        // var keys = ['basestyle', 'color', 'size', 'quantityavailable', 'quantityonorder', 'totalquantityintransit', 'totalquantityonhand']
        var keys = ['basestyle', 'color', 'size', 'quantityavailable', 'quantityonorder', 'totalquantityintransit', 'totalquantityonhand']
        
        var arr = []
        arr.push(keys)
        this.items.forEach(function (val) {
          var o = {}
          keys.forEach(function (key) {
            o[key] = val[key]
          })
          arr.push(o)
        })
        // arr.pop(headers)
        // arr.unshift(headers)
        return arr.map(item => Object.values(item).join(',')).join('\n')
      } else {
        return ''
      }
    },
    csvCode () {
      return 'data:text/csv;charset=utf-8,SEP=,%0A' + encodeURIComponent(this.csvContent)
    }
  },
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
